export const STATI = {
    NEWSLETTER: 'Newsletter',
    ISCRITTO: 'Iscritto',
    RICHIESTA: 'Richiesta',
    PREVENTIVO: 'Preventivo'
};

export const transizioniStato = {
    [STATI.NEWSLETTER]: {
        [STATI.RICHIESTA]: STATI.RICHIESTA,
        [STATI.ISCRIZIONE]: STATI.ISCRIZIONE,
        [STATI.PREVENTIVO]: STATI.PREVENTIVO
    },
    [STATI.ISCRITTO]: {
        [STATI.NEWSLETTER]: STATI.ISCRITTO,
        [STATI.RICHIESTA]: STATI.RICHIESTA,
        [STATI.PREVENTIVO]: STATI.PREVENTIVO
    },
    [STATI.RICHIESTA]: {
        [STATI.NEWSLETTER]: STATI.RICHIESTA,
        [STATI.ISCRIZIONE]: STATI.RICHIESTA,
        [STATI.PREVENTIVO]: STATI.PREVENTIVO
    },
    [STATI.PREVENTIVO]: {
        [STATI.NEWSLETTER]: STATI.PREVENTIVO,
        [STATI.ISCRIZIONE]: STATI.PREVENTIVO,
        [STATI.PREVENTIVO]: STATI.PREVENTIVO,
        [STATI.RICHIESTA]: STATI.RICHIESTA
    }
};

/**
 * Funzione per gestire la transizione di stato dei lead
 */
export function updateLeadStatus(currentState, action) {
    const transizioni = transizioniStato[currentState];
    if (transizioni && transizioni.hasOwnProperty(action)) {
        return transizioni[action];
    } else {
        return action;
    }
}
